/**
 * Time formatting helpers — DISPLAY ONLY.
 * Never use these for values stored, sent to the API, or used as form input.
 */

/**
 * Convert an 'HH:MM' or 'HH:MM:SS' wall-clock string to 'h:mm AM/PM'.
 * - strips the leading zero on the hour
 * - returns '--' for empty/null
 * - if the input is NOT a wall-clock time string, returns it unchanged
 */
export function fmtTime12(t) {
  if (!t && t !== 0) return '--';
  const s = String(t);
  const m = s.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return s;
  let h = parseInt(m[1], 10);
  if (isNaN(h)) return s;
  const ap = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m[2]} ${ap}`;
}

/** Format a start–end wall-clock range as 'h:mm AM/PM – h:mm AM/PM'. */
export function fmtRange12(a, b) {
  return `${fmtTime12(a)} – ${fmtTime12(b)}`;
}

// LOCAL calendar date as YYYY-MM-DD (NOT toISOString(), which is UTC and shifts the day
// back for AEST users — silently excluding "today" from default date ranges).
export const isoDate = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
